export default __webpack_public_path__ + "static/media/complete-icon.a4f78a87.svg";